(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7522,3781],{

/***/ 14957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

/***/ }),

/***/ 38959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m12 17.27 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08z"
}), 'StarRounded');

/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 42843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PercentageIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function PercentageIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 24,
        height: props.size || 24,
        viewBox: "0 0 14.984 15.292"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            transform: "translate(0 0)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    className: "a",
                    fill: props.color || "#000000",
                    cx: "0.639",
                    cy: "0.639",
                    rx: "0.639",
                    ry: "0.639",
                    transform: "translate(4.821 5.708)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    className: "a",
                    fill: props.color || "#000000",
                    cx: "0.639",
                    cy: "0.639",
                    rx: "0.639",
                    ry: "0.639",
                    transform: "translate(8.882 8.303)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: props.color,
                    className: "a",
                    d: "M19.711,8.49l-.232-.316a1,1,0,0,1-.009-1.163l.226-.32a1,1,0,0,0-.345-1.454l-.345-.185a.993.993,0,0,1-.511-1.043l.066-.385a1,1,0,0,0-.94-1.159l-.392-.016a1,1,0,0,1-.915-.718l-.11-.376A.993.993,0,0,0,14.854.719l-.36.154A.993.993,0,0,1,13.359.622L13.1.331a.993.993,0,0,0-1.492.013l-.257.295A1,1,0,0,1,10.22.9L9.856.754a1,1,0,0,0-1.341.658l-.1.379a.989.989,0,0,1-.9.73l-.392.022A1,1,0,0,0,6.2,3.718l.072.385a.993.993,0,0,1-.5,1.05l-.342.191A.994.994,0,0,0,5.112,6.8l.232.316A1,1,0,0,1,5.353,8.28l-.226.32a1,1,0,0,0,.345,1.454l.345.185a.993.993,0,0,1,.511,1.043l-.066.385a1,1,0,0,0,.94,1.159l.392.016a1,1,0,0,1,.915.718l.11.376a.993.993,0,0,0,1.351.636l.36-.154a.993.993,0,0,1,1.134.251l.26.291a.993.993,0,0,0,1.492-.013l.257-.295a1,1,0,0,1,1.131-.266l.363.15a1,1,0,0,0,1.341-.658l.1-.379a.989.989,0,0,1,.9-.73l.392-.022a1,1,0,0,0,.921-1.175l-.072-.385a.993.993,0,0,1,.5-1.05l.342-.191A.993.993,0,0,0,19.711,8.49ZM8.835,6.347a1.542,1.542,0,1,1,1.542,1.542A1.541,1.541,0,0,1,8.835,6.347Zm1.839,3.976a.377.377,0,0,1-.53.05h0a.377.377,0,0,1-.05-.53l4.045-4.873a.376.376,0,1,1,.58.479Zm3.766.16a1.542,1.542,0,1,1,1.542-1.542A1.541,1.541,0,0,1,14.44,10.483Z",
                    transform: "translate(-4.919 0)"
                })
            ]
        })
    }));
}


/***/ }),

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 38855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(52479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background-color: #eeeef1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n\n  color: #646464;\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-3f72cec7-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-3f72cec7-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-3f72cec7-2"
})(_templateObject2(), function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-3f72cec7-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-3f72cec7-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js





var Switch = function(props) {
    var ref = (0,react.useContext)(context/* OrderContext */.y), onChangeActiveTab = ref.onChangeActiveTab, activeTab = ref.activeTab;
    var _tabsData = props.tabsData, tabsData = _tabsData === void 0 ? [] : _tabsData, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor, width = props.width;
    var tabRoundness = (0,util/* roundnessCalculator */.M)(roundness) || "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchContainer, {
        backgroundColor: backgroundColor,
        fluid: fluid,
        fontSize: 14,
        className: "tw-h-[48px]",
        style: {
            borderRadius: tabRoundness
        },
        children: tabsData.map(function(param) {
            var text = param.text, key = param.key;
            var isActiveTab = activeTab === key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: width,
                onClick: function() {
                    return onChangeActiveTab(key);
                },
                isActiveTab: isActiveTab,
                className: "tw-relative tw-h-full tw-w-full tw-bg-transparent",
                style: {
                    borderRadius: tabRoundness
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isActiveTab ? "tw-absolute -tw-inset-x-[5px] -tw-inset-y-[2px] tw-z-10 tw-flex tw-items-center tw-justify-center tw-text-white" : "",
                    style: {
                        backgroundColor: isActiveTab ? backgroundColor : "transparent",
                        borderRadius: tabRoundness
                    },
                    children: text
                })
            }, key);
        })
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 8710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FM": function() { return /* binding */ MB7_SORT_FILTER_TEMP_STORAGE_KEY; },
/* harmony export */   "Tr": function() { return /* binding */ getStoredMB7SortAndFilterConfig; },
/* harmony export */   "Wu": function() { return /* binding */ scrollIfItemPreviouslyClicked; },
/* harmony export */   "lr": function() { return /* binding */ setMB7SortAndFilterConfig; }
/* harmony export */ });
/* unused harmony export MB7_SORT_FILTER_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87243);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44779);




var MB7_SORT_FILTER_STORAGE_KEY = "mb7SortAndFilterConfig";
var MB7_SORT_FILTER_TEMP_STORAGE_KEY = "mb7SortAndFilterConfigTemp";
function scrollIfItemPreviouslyClicked() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__/* .scrollOnPageLoad */ .l)();
    if (scrollConfig.toScroll) {
        try {
            var y_scroll = scrollConfig.y_scroll;
            setTimeout(function() {
                sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
                window.scrollTo({
                    top: y_scroll
                });
            }, 300);
        } catch (err) {
            console.log("timeout time error:", err);
        }
    }
}
function getStoredMB7SortAndFilterConfig() {
    if (_utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY)) {
        return _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY);
    }
    return {
        filterAppliedCounter: 0,
        sortType: 0,
        collectionId: null,
        cid: null,
        isNextPage: true,
        pageNo: 1,
        filteredItems: [],
        filteredOptions: [],
        allowReset: true,
        filterAppliedCounterChanged: false,
        sortTypeChanged: false
    };
}
function setMB7SortAndFilterConfig(data) {
    var temp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentStoredData = getStoredMB7SortAndFilterConfig();
    var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, currentStoredData, data);
    if (temp) {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_TEMP_STORAGE_KEY, newData);
    } else {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_STORAGE_KEY, newData);
    }
}


/***/ }),

/***/ 93247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductDisplayWidget; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductDisplayWidget/GridView/Hybrid.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin-top: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n  margin: 0 auto;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(\n      ",
        ",\n      minmax(0, 1fr)\n    );\n    row-gap: ",
        ";\n    column-gap: ",
        ";\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(\n      ",
        ",\n      minmax(0, 1fr)\n    );\n    row-gap: ",
        ";\n    column-gap: ",
        ";\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000000;\n  font-weight: 500;\n  margin-bottom: 2rem;\n  text-align: center;\n\n  @media screen and (min-width: 767px) {\n    font-size: 24px;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 24px;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 50;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  border: 2px solid #ffffff;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  color: #6f6e6e;\n  font-size: 22px;\n  letter-spacing: 0;\n  cursor: pointer;\n  & > span {\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    background-color: #000000;\n    width: 0;\n    height: 1px;\n    transition: width ease-in-out 300ms;\n  }\n  &:hover {\n    color: #000000;\n    & > span {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-8cf1bc84-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding || "4rem 0 2rem";
});
var Heading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-8cf1bc84-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-8cf1bc84-2"
})(_templateObject2(), function(props) {
    var ref, ref1, ref2;
    return ((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.desktop) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.grid) === null || ref2 === void 0 ? void 0 : ref2.cols) || 3;
}, function(props) {
    var ref, ref1, ref2;
    return "".concat(((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.desktop) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.spacing) === null || ref2 === void 0 ? void 0 : ref2.row) || 60, "px");
}, function(props) {
    var ref, ref1, ref2;
    return "".concat(((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.desktop) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.spacing) === null || ref2 === void 0 ? void 0 : ref2.col) || 24, "px");
}, function(props) {
    var ref, ref1, ref2;
    return ((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.mobile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.grid) === null || ref2 === void 0 ? void 0 : ref2.cols) || 2;
}, function(props) {
    var ref, ref1, ref2;
    return "".concat(((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.mobile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.spacing) === null || ref2 === void 0 ? void 0 : ref2.row) || 24, "px");
}, function(props) {
    var ref, ref1, ref2;
    return "".concat(((ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.mobile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.spacing) === null || ref2 === void 0 ? void 0 : ref2.col) || 16, "px");
});
var ListingHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-8cf1bc84-3"
})(_templateObject3());
var AllCategorySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-8cf1bc84-4"
})(_templateObject4());
var AllCategoryButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-8cf1bc84-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var ViewMore = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ViewMore",
    componentId: "sc-8cf1bc84-6"
})(_templateObject6());

// EXTERNAL MODULE: ./src/components/DesignSystem/ProductItemWidget/index.js + 3 modules
var ProductItemWidget = __webpack_require__(7780);
// EXTERNAL MODULE: ./src/utils/returnCommonConfigData.js
var returnCommonConfigData = __webpack_require__(43090);
// EXTERNAL MODULE: ./src/components/Link/index.tsx + 1 modules
var Link = __webpack_require__(73409);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(40190);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductDisplayWidget/GridView/index.js










var CategoryProductGridView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(false), viewMore = ref7[0], setViewMore = ref7[1];
    var activeCategoryData = props.activeCategoryData, categoryItems = props.categoryItems, onItemsImageClick = props.onItemsImageClick, getLink = props.getLink;
    var ref8 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref8.widgetContextState.globalStyle;
    var ref9 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref9.infoList, isProductCardEnabled = ref9.isEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) ? true : false;
    var maxItemRender = function(items) {
        var ref;
        var itemsinGrid = (activeCategoryData === null || activeCategoryData === void 0 ? void 0 : (ref = activeCategoryData.products_config) === null || ref === void 0 ? void 0 : ref.max_items) || 0;
        if (!viewMore && (items === null || items === void 0 ? void 0 : items.length) && itemsinGrid) {
            var newArr = items.slice(0, itemsinGrid);
            return newArr;
        }
        return items;
    };
    var toggleViewMore = function() {
        setViewMore(function(s) {
            return !s;
        });
    };
    var isShowViewMoreBtn = function() {
        var ref, ref1;
        return (activeCategoryData === null || activeCategoryData === void 0 ? void 0 : (ref = activeCategoryData.products_config) === null || ref === void 0 ? void 0 : ref.max_items) && (activeCategoryData === null || activeCategoryData === void 0 ? void 0 : (ref1 = activeCategoryData.products_config) === null || ref1 === void 0 ? void 0 : ref1.max_items) < (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        padding: "0",
        children: [
            (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.is_show_heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingHeading, {
                id: "listing-".concat(activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.id),
                className: "f3 fw5 mb4 tc",
                style: {
                    margin: props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.customStyle) === null || ref2 === void 0 ? void 0 : ref2.margin,
                    textAlign: props === null || props === void 0 ? void 0 : (ref3 = props.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customStyle) === null || ref4 === void 0 ? void 0 : ref4.textAlign
                },
                children: (activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.name) || (activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.hasOwnProperty("is_custom_tag")) || "Available Items"
            }),
            activeCategoryData ? !showCustomProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Listing, {
                        config: (0,returnCommonConfigData/* returnCommonConfigData */.Z)({
                            activeCategoryConfig: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.products_config,
                            productConfig: props === null || props === void 0 ? void 0 : (ref5 = props.config) === null || ref5 === void 0 ? void 0 : ref5.product_config
                        }),
                        children: (ref6 = maxItemRender(categoryItems)) === null || ref6 === void 0 ? void 0 : ref6.map(function(data) {
                            var ref, ref1;
                            return (data === null || data === void 0 ? void 0 : data.is_active) === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: getLink(data, routes.getRoute),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemWidget/* ProductCardWidget1 */.e, {
                                    data: data,
                                    onItemClick: function() {
                                        return onItemsImageClick(data);
                                    },
                                    showButton: props.showATCBtn,
                                    noTags: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.hasOwnProperty("is_custom_tag"),
                                    categoryConfig: (0,returnCommonConfigData/* returnCommonConfigData */.Z)({
                                        activeCategoryConfig: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.products_config,
                                        productConfig: props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.product_config
                                    }),
                                    productConfig: props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.product_config
                                })
                            }, data.id);
                        })
                    }),
                    isShowViewMoreBtn() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tc w-100 mt5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMore, {
                            onClick: toggleViewMore,
                            children: [
                                viewMore ? "View Less" : "View More",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                            ]
                        })
                    }) : null
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                productList: maxItemRender(categoryItems),
                customClass: "tw-my-[40px]",
                calculateSelfDimensions: true,
                children: isShowViewMoreBtn() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tc w-100 mt5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMore, {
                        onClick: toggleViewMore,
                        children: [
                            viewMore ? "View Less" : "View More",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    })
                }) : null
            }) : null
        ]
    });
};
/* harmony default export */ var GridView = (CategoryProductGridView);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/calculateArrowTopPos.js
var calculateArrowTopPos = __webpack_require__(71386);
// EXTERNAL MODULE: ./src/utils/showViewMoreBtn.js
var showViewMoreBtn = __webpack_require__(52925);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/index.ts + 11 modules
var ProductCard = __webpack_require__(32755);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(81241);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(2386);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductDisplayWidget/HorizontalView/index.js




















var CategoryProductHorizontalView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var router = (0,next_router.useRouter)();
    var activeCategoryData = props.activeCategoryData, categoryItems = props.categoryItems, onItemsImageClick = props.onItemsImageClick, getLink = props.getLink;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref14 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref14.widgetContextState, globalStyle = _widgetContextState.globalStyle, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = (isBuilder ? previewDevice === "mobile" : false) || deviceType === "mobile";
    var ref15 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref15.infoList, isProductCardEnabled = ref15.isEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) ? true : false;
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config);
    var maxItemRender = function(items) {
        var maxItemsToShow = props.config.max_items || 0;
        if ((items === null || items === void 0 ? void 0 : items.length) && maxItemsToShow) {
            var newArr = items.slice(0, maxItemsToShow);
            return newArr;
        }
        return items;
    };
    var onViewMoreCtaClick = function() {
        var ref;
        if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            router.push((0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(activeCategoryData.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain), undefined, {
                shallow: true
            });
        } else {
            var ref2;
            router.push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(activeCategoryData.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
    };
    var scrollNewReleaseSection = function(scrollType, catId) {
        var scrollMovPos = deviceWidth/* deviceWidth */.o < 767 ? deviceWidth/* deviceWidth */.o : 330;
        var element = document.getElementById("scroll-wrapper-".concat(catId));
        var leftArrowEle = document.getElementsByClassName("category-list-left-arrow-".concat(catId));
        var rightArrowEle = document.getElementsByClassName("category-list-right-arrow-".concat(catId));
        var scrollPos = 0;
        if (element) {
            scrollPos = element.scrollLeft;
            if (scrollType === "left") {
                if (scrollPos < 130) scrollPos = 0;
                else scrollPos -= scrollMovPos;
            } else {
                scrollPos += scrollMovPos;
            }
            if (scrollPos >= 0) {
                element.scrollLeft = scrollPos;
                if (leftArrowEle) {
                    !scrollPos ? leftArrowEle[0].classList.add("dn") : leftArrowEle[0].classList.remove("dn");
                }
                if (rightArrowEle) {
                    if (scrollPos + element.offsetWidth >= element.scrollWidth) {
                        rightArrowEle[0].classList.add("dn");
                    } else {
                        rightArrowEle[0].classList.remove("dn");
                    }
                }
            }
        }
    };
    // calculate arrow Y axis position in px
    var arrowTopPos = function() {
        var ref;
        return (0,calculateArrowTopPos/* calculateArrowTopPos */.K)((0,returnCommonConfigData/* returnCommonConfigData */.Z)({
            activeCategoryConfig: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.products_config,
            productConfig: props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.product_config
        }));
    };
    var cardSelfDimensions = (0,ProductListWrapper_utils/* useProductCardDimensions */.lT)({
        // on mobile - width is set as 40vw in mobile & 300px in desktop
        imageWidth: isMobile ? checkRenderEnv/* IS_SERVER */.W6 ? 200 : document.documentElement.clientWidth * 0.4 : 300
    }).cardSelfDimensions;
    if (activeCategoryData && (props === null || props === void 0 ? void 0 : props.categoryTagType) === constants/* CATEGORY_TYPE.TAG */.MI.TAG && !(activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.is_active)) return null;
    return (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "horizontal-category-display-widget relative mb5-ns mb0",
        style: {
            padding: "0px 20px"
        },
        children: [
            ((ref = props.config) === null || ref === void 0 ? void 0 : ref.is_show_heading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "horizontal-category-display-widget__title tc fw6",
                style: {
                    margin: props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.customStyle) === null || ref2 === void 0 ? void 0 : ref2.margin,
                    textAlign: props === null || props === void 0 ? void 0 : (ref3 = props.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customStyle) === null || ref4 === void 0 ? void 0 : ref4.textAlign
                },
                children: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.name
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                style: {
                                    top: arrowTopPos()
                                },
                                alt: "Left Button",
                                src: "/assets/icons/arrowLeftIconCircleDark.png",
                                className: "category-list-left-arrow-".concat(props === null || props === void 0 ? void 0 : (ref5 = props.config) === null || ref5 === void 0 ? void 0 : ref5.category_id, " arrow-btns absolute left-1-ns left-0 img pointer dn"),
                                onClick: function() {
                                    var ref;
                                    return scrollNewReleaseSection("left", props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                style: {
                                    top: arrowTopPos()
                                },
                                alt: "Right Button",
                                src: "/assets/icons/arrowRightIconCircleDark.png",
                                className: "category-list-right-arrow-".concat(props === null || props === void 0 ? void 0 : (ref6 = props.config) === null || ref6 === void 0 ? void 0 : ref6.category_id, " arrow-btns absolute right-1-ns right-0 img pointer"),
                                onClick: function() {
                                    var ref;
                                    return scrollNewReleaseSection("right", props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.category_id);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "scroll-wrapper",
                        id: "scroll-wrapper-".concat(props === null || props === void 0 ? void 0 : (ref7 = props.config) === null || ref7 === void 0 ? void 0 : ref7.category_id),
                        children: [
                            (ref8 = maxItemRender(categoryItems)) === null || ref8 === void 0 ? void 0 : ref8.map(function(data, index) {
                                var ref, ref1;
                                return (data === null || data === void 0 ? void 0 : data.is_active) === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-card",
                                    children: !showCustomProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: getLink(data, routes.getRoute),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemWidget/* ProductCardWidget1 */.e, {
                                            data: data,
                                            onItemClick: function() {
                                                return onItemsImageClick(data);
                                            },
                                            showButton: props.showATCBtn,
                                            noTags: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.hasOwnProperty("is_custom_tag"),
                                            categoryConfig: (0,returnCommonConfigData/* returnCommonConfigData */.Z)({
                                                activeCategoryConfig: activeCategoryData === null || activeCategoryData === void 0 ? void 0 : activeCategoryData.products_config,
                                                productConfig: props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.product_config
                                            }),
                                            productConfig: props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.product_config
                                        }, data.id)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard.ProductCard, {
                                        productData: data,
                                        itemIndex: index,
                                        onItemClick: function() {
                                            return onItemsImageClick(data);
                                        },
                                        configs: {
                                            cardWrapperConfigs: cardWrapperConfigs,
                                            isMobile: isMobile,
                                            dimensions: {
                                                cardWidth: cardSelfDimensions.cardWidth,
                                                cardHeight: cardSelfDimensions.cardHeight
                                            }
                                        }
                                    })
                                }, data.id);
                            }),
                            (0,showViewMoreBtn/* showViewMoreBtn */.M)(props === null || props === void 0 ? void 0 : (ref9 = props.config) === null || ref9 === void 0 ? void 0 : ref9.max_items, categoryItems) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "category-card pointer flex items-start view-more-box w-100 mb5",
                                onClick: onViewMoreCtaClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "view-more-box--inner relative",
                                    style: {
                                        paddingTop: "".concat((activeCategoryData === null || activeCategoryData === void 0 ? void 0 : (ref10 = activeCategoryData.products_config) === null || ref10 === void 0 ? void 0 : ref10.aspect_ratio) || (props === null || props === void 0 ? void 0 : (ref11 = props.config) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.product_config) === null || ref12 === void 0 ? void 0 : ref12.aspect_ratio) || 10000 / (storeData === null || storeData === void 0 ? void 0 : (ref13 = storeData.theme) === null || ref13 === void 0 ? void 0 : ref13.product_aspect_ratio) || 100, "%")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMore, {
                                        children: [
                                            "View More",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                        ]
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml1 ml5-ns ph2 ph5-ns"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HorizontalView = (CategoryProductHorizontalView);

// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/assets/svgExports/PercentageIcon.js
var PercentageIcon = __webpack_require__(42843);
;// CONCATENATED MODULE: ./src/assets/svgExports/RuppeeIcon.js

var RuppeeIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "45.498",
        height: props.height || "45.498",
        viewBox: "0 0 45.498 45.498",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Group_160895",
            "data-name": "Group 160895",
            transform: "translate(-218.258 -416)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_305453",
                    "data-name": "Path 305453",
                    d: "M69.614,92.363A22.749,22.749,0,1,1,85.7,85.7a22.6,22.6,0,0,1-16.086,6.663Z",
                    transform: "translate(171.393 369.135)",
                    fill: "#18D8B3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_305454",
                    "data-name": "Path 305454",
                    d: "M186.026,146.741h0l-1.848,0a8.31,8.31,0,0,0-1.517-3.359l3.372-.006a1.681,1.681,0,0,0,0-3.362h0l-9.975.018-.106,0h-.02l-5.525.013a1.681,1.681,0,0,0,.011,3.362l5.641-.01a5.048,5.048,0,0,1,4.647,3.353l-10.3.019a1.681,1.681,0,0,0,0,3.362h0l10.293-.019a5.053,5.053,0,0,1-4.743,3.368l-5.557.013a1.7,1.7,0,0,0-1.115,2.935l12.265,10.936a1.681,1.681,0,0,0,2.237-2.509l-8.984-8.01,1.162,0a8.423,8.423,0,0,0,8.217-6.736l1.851,0a1.681,1.681,0,0,0,0-3.362Z",
                    transform: "translate(62.794 286.115)",
                    fill: "#fff"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/CategoryCoupon/categorycoupon.styles.js

function categorycoupon_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 112px;\n  width: 353px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  position: relative;\n  overflow: hidden;\n  &:after {\n    height: 100%;\n    width: 100%;\n    background-color: white;\n    position: absolute;\n    content: '';\n    transform: rotate(45deg);\n    transform-origin: bottom right;\n  }\n"
    ]);
    categorycoupon_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 26px;\n  font-weight: 700;\n  margin-right: 56px;\n"
    ]);
    categorycoupon_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 112px;\n  width: 400px;\n  background-color: ",
        ";\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    categorycoupon_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 112px;\n  width: 400px;\n  background-color: ",
        ";\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    categorycoupon_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  border: 1px solid #efefef;\n  width: 1200px;\n  margin-left: ",
        ";\n"
    ]);
    categorycoupon_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -39px;\n  margin-top: -13px;\n"
    ]);
    categorycoupon_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function categorycoupon_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: -24px;\n"
    ]);
    categorycoupon_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n  width: 333px;\n  display: flex;\n  flex-direction: row;\n  background-color: #fdfdfd;\n  align-items: center;\n  border-radius: 5px;\n  border: 1px solid #f8f8f8;\n  margin-left: ",
        ";\n  justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 19px;\n  width: 91px;\n  display: flex;\n  margin-left: 24px;\n  flex-direction: row;\n  background-color: #fdfdfd;\n  border-radius: 10px;\n  border: 1px solid #f8f8f8;\n  transform: translateY(10px);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 10px;\n  align-items: center;\n  font-weight: 500;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-right: 12px;\n  margin-bottom: 16px;\n  border-radius: 4px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var CategoryCouponLeftSlanted = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponLeftSlanted",
    componentId: "sc-7cc5cae-0"
})(categorycoupon_styles_templateObject(), function(props) {
    return props.backgroundColor || "#F8F8F8";
});
var CategoryCouponLeftSlantedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponLeftSlantedText",
    componentId: "sc-7cc5cae-1"
})(categorycoupon_styles_templateObject1());
var CategoryCouponMiddle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponMiddle",
    componentId: "sc-7cc5cae-2"
})(categorycoupon_styles_templateObject2(), function(props) {
    return props.backgroundColor || "white";
});
var CategoryCouponEnd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponEnd",
    componentId: "sc-7cc5cae-3"
})(categorycoupon_styles_templateObject3(), function(props) {
    return props.backgroundColor || "white";
});
var CategoryCouponContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponContainer",
    componentId: "sc-7cc5cae-4"
})(categorycoupon_styles_templateObject4(), function(props) {
    return props.ml;
});
var CategoryCouponMiddleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponMiddleText",
    componentId: "sc-7cc5cae-5"
})(categorycoupon_styles_templateObject5());
var CategoryCouponEndText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponEndText",
    componentId: "sc-7cc5cae-6"
})(categorycoupon_styles_templateObject6());
var CategoryCouponContainerMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponContainerMobile",
    componentId: "sc-7cc5cae-7"
})(_templateObject7(), function(props) {
    return props.ml;
});
var CategoryCouponTopLeftMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponTopLeftMobile",
    componentId: "sc-7cc5cae-8"
})(_templateObject8());
var CategoryCouponTopLeftTextMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponTopLeftTextMobile",
    componentId: "sc-7cc5cae-9"
})(_templateObject9());
var CategoryCouponMiddleTextMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponMiddleTextMobile",
    componentId: "sc-7cc5cae-10"
})(_templateObject10());
var CategoryCouponEndMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponEndMobile",
    componentId: "sc-7cc5cae-11"
})(_templateObject11(), function(props) {
    return props.backgroundColor || "white";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/CategoryCoupon/index.js







var MAX_CATEGORYTAG_NAME = deviceWidth/* deviceWidth */.o > 767 ? 4 : 2;
function renderCategoryTagName(coupon) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var categoryTagName = [];
    var categoryTagNamesTotalLength = 0;
    coupon === null || coupon === void 0 ? void 0 : (ref = coupon.category_id_list) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        if (categoryTagName.length < MAX_CATEGORYTAG_NAME && item.name) {
            categoryTagName.push(item.name);
        }
    });
    coupon === null || coupon === void 0 ? void 0 : (ref1 = coupon.tag_id_list) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
        if (categoryTagName.length < MAX_CATEGORYTAG_NAME && item.name) {
            categoryTagName.push(item.name);
        }
    });
    var categoryTagNameRenderLength = MAX_CATEGORYTAG_NAME < categoryTagName.length ? MAX_CATEGORYTAG_NAME : categoryTagName.length;
    if ((coupon === null || coupon === void 0 ? void 0 : (ref2 = coupon.category_id_list) === null || ref2 === void 0 ? void 0 : ref2.length) && (coupon === null || coupon === void 0 ? void 0 : (ref3 = coupon.tag_id_list) === null || ref3 === void 0 ? void 0 : ref3.length)) categoryTagNamesTotalLength = (coupon === null || coupon === void 0 ? void 0 : (ref4 = coupon.category_id_list) === null || ref4 === void 0 ? void 0 : ref4.length) + (coupon === null || coupon === void 0 ? void 0 : (ref5 = coupon.tag_id_list) === null || ref5 === void 0 ? void 0 : ref5.length);
    else {
        var ref6, ref7, ref8, ref9;
        if (coupon === null || coupon === void 0 ? void 0 : (ref6 = coupon.category_id_list) === null || ref6 === void 0 ? void 0 : ref6.length) {
            var ref10;
            categoryTagNamesTotalLength = coupon === null || coupon === void 0 ? void 0 : (ref10 = coupon.category_id_list) === null || ref10 === void 0 ? void 0 : ref10.length;
        } else if (coupon === null || coupon === void 0 ? void 0 : (ref7 = coupon.tag_id_list) === null || ref7 === void 0 ? void 0 : ref7.length) {
            var ref11;
            categoryTagNamesTotalLength = coupon === null || coupon === void 0 ? void 0 : (ref11 = coupon.tag_id_list) === null || ref11 === void 0 ? void 0 : ref11.length;
        } else if (!(coupon === null || coupon === void 0 ? void 0 : (ref8 = coupon.category_id_list) === null || ref8 === void 0 ? void 0 : ref8.length) && !(coupon === null || coupon === void 0 ? void 0 : (ref9 = coupon.tag_id_list) === null || ref9 === void 0 ? void 0 : ref9.length)) {
            categoryTagNamesTotalLength = 0;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: deviceWidth/* deviceWidth */.o > 767 ? "f12px mt4px fw4" : "f10px mt4px fw4",
            children: [
                categoryTagName.map(function(item, index) {
                    return index < categoryTagNameRenderLength - 1 ? "".concat(item, ", ") : index === categoryTagNameRenderLength - 1 && "".concat(item);
                }),
                categoryTagNamesTotalLength - MAX_CATEGORYTAG_NAME > 0 ? " +".concat(categoryTagNamesTotalLength - MAX_CATEGORYTAG_NAME, " more") : ""
            ]
        })
    });
}
function categoryCouponDesktop(props, additionalProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponContainer, {
        ml: props.desktopMarginLeft,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponLeftSlanted, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr3",
                        children: additionalProps.discount_type === "percentage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                            color: "#EF8B36",
                            width: 48,
                            height: 48
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RuppeeIcon, {
                            width: 48,
                            height: 48
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponLeftSlantedText, {
                        children: "Special Offer"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponMiddle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponMiddleText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fw7 f26px",
                            children: [
                                additionalProps.discount_type === "percentage" ? "Get Upto ".concat(props.coupon.discount, "% off") : "FLAT ₹".concat(props.coupon.discount, " off"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                            ]
                        }),
                        additionalProps.getCategoryTagNameToRender
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponEnd, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponEndText, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mr34px ba br2 b--dashed ph18px pv8px f13px b--moon-gray",
                        children: [
                            "Use Code:\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fw7 flex",
                                children: props.coupon.promo_code
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function categoryCouponMobile(props, additionalProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponTopLeftMobile, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr4px ml4px",
                        children: additionalProps.discount_type === "percentage" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIcon/* PercentageIcon */.S, {
                            color: "#EF8B36",
                            width: 12,
                            height: 12
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RuppeeIcon, {
                            width: 12,
                            height: 12
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponTopLeftTextMobile, {
                        children: "Special Offer"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponContainerMobile, {
                ml: props.mobileMarginLeft,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCouponMiddleTextMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "fw7 f16px",
                                children: [
                                    additionalProps.discount_type === "percentage" ? "Get Upto ".concat(props.coupon.discount, "% off") : "FLAT ₹".concat(props.coupon.discount, " off"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            additionalProps.getCategoryTagNameToRender
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponEndMobile, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex pv4px ph8px br2 ba b--dashed f10px b--moon-gray",
                            children: [
                                "Use Code:\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw7 flex",
                                    children: props.coupon.promo_code
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function CategoryCoupon(props) {
    var getCategoryTagNameToRender = (0,react.useMemo)(function() {
        return renderCategoryTagName(props.coupon);
    }, [
        props.coupon
    ]);
    var discountType = props.coupon.discount_type;
    var additionalProps = {
        discount_type: discountType,
        getCategoryTagNameToRender: getCategoryTagNameToRender
    };
    return deviceWidth/* deviceWidth */.o > 767 ? categoryCouponDesktop(props, additionalProps) : categoryCouponMobile(props, additionalProps);
}
/* harmony default export */ var DesignSystem_CategoryCoupon = (CategoryCoupon);

;// CONCATENATED MODULE: ./src/components/DesignSystem/CouponDisplayWidget/CategoryCouponHorizontalView.styles.js

function CategoryCouponHorizontalView_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  width: 100vw;\n  margin-bottom : 68px;\n  -ms-overflow-style: none; \n  scrollbar-width: none; \n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n"
    ]);
    CategoryCouponHorizontalView_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryCouponHorizontalView_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: -52px;\n  margin-bottom: 42px;\n  @media screen and (max-width: 768px) {\n    margin-bottom: 18px;\n  }\n"
    ]);
    CategoryCouponHorizontalView_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryCouponHorizontalView_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 8px;\n  height: 8px;\n  border-radius: 1rem;\n  margin-left: 3px;\n  border: 1px solid black;\n  background-color: ",
        ";\n"
    ]);
    CategoryCouponHorizontalView_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CategoryCouponHorizontalViewContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryCouponHorizontalViewContainer",
    componentId: "sc-616c1d30-0"
})(CategoryCouponHorizontalView_styles_templateObject());
var SliderDotContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SliderDotContainer",
    componentId: "sc-616c1d30-1"
})(CategoryCouponHorizontalView_styles_templateObject1());
var SliderDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SliderDot",
    componentId: "sc-616c1d30-2"
})(CategoryCouponHorizontalView_styles_templateObject2(), function(props) {
    return props.backgroundColor ? props.backgroundColor : "white";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/CouponDisplayWidget/CategoryCouponHorizontalView.js











var max_point_render = 9;
var pointToBeFilled = "0";
function CategoryCouponHorizontalView() {
    var uniqueCouponId = function uniqueCouponId(arr) {
        return arr.filter(function(item, index) {
            return arr.indexOf(item) === index;
        });
    };
    var renderDottedCircle = function renderDottedCircle() {
        var uniqueCouponIdNames = uniqueCouponId(couponIdNames);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDotContainer, {
            children: !!(uniqueCouponIdNames === null || uniqueCouponIdNames === void 0 ? void 0 : uniqueCouponIdNames.length) && uniqueCouponIdNames.map(function(id_name, index) {
                return index < max_point_render && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: id_name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDot, {
                        backgroundColor: pointToBeFilled === id_name ? "black" : ""
                    })
                });
            })
        });
    };
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var cid = router.query.cid;
    var ref = (0,react.useState)([]), couponIdNames = ref[0], setCouponIdNames = ref[1];
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            couponList: state.promoReducer.couponsList,
            isCustomWebsite: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.custom_theme_flag
        };
    }), couponList = ref1.couponList, isCustomWebsite = ref1.isCustomWebsite;
    var getCategoryCoupons = (0,react.useMemo)(function() {
        var categorycoupons = [];
        if (couponList === null || couponList === void 0 ? void 0 : couponList.length) {
            for(var i = 0; i < (couponList === null || couponList === void 0 ? void 0 : couponList.length); i++){
                var ref, ref1;
                for(var j = 0; j < ((ref = couponList[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.category_id_list) === null || ref1 === void 0 ? void 0 : ref1.length); j++){
                    var ref2, ref3;
                    if (((ref3 = (ref2 = couponList[i]) === null || ref2 === void 0 ? void 0 : ref2.category_id_list[j]) === null || ref3 === void 0 ? void 0 : ref3.id.toString()) === cid) {
                        categorycoupons.push(couponList[i]);
                    }
                }
            }
        }
        if (categorycoupons.length > 0) {
            dispatch((0,common/* couponBannerPresent */.m2)());
        }
        return categorycoupons;
    }, [
        cid,
        couponList
    ]);
    (0,react.useEffect)(function() {
        return function() {
            return dispatch((0,common/* couponBannerAbsent */.P6)());
        };
    }, []);
    (0,react.useEffect)(function() {
        /* Fill couponIdNames to get their position after they are mapped & their id attribute has been set 
      thus, forcing next useEffect to hit  */ !checkRenderEnv/* IS_SERVER */.W6 && (getCategoryCoupons === null || getCategoryCoupons === void 0 ? void 0 : getCategoryCoupons.length) && !(couponIdNames === null || couponIdNames === void 0 ? void 0 : couponIdNames.length) && getCategoryCoupons.forEach(function(promo, index) {
            var couponIdNames = [];
            var uniqueCouponId = "".concat(index).concat(promo.promo_id);
            couponIdNames.push(uniqueCouponId);
            setCouponIdNames(couponIdNames);
        });
    }, [
        getCategoryCoupons === null || getCategoryCoupons === void 0 ? void 0 : getCategoryCoupons.length
    ]);
    (0,react.useEffect)(function() {
        if (!checkRenderEnv/* IS_SERVER */.W6 && (couponIdNames === null || couponIdNames === void 0 ? void 0 : couponIdNames.length) && (couponIdNames === null || couponIdNames === void 0 ? void 0 : couponIdNames.length) === (getCategoryCoupons === null || getCategoryCoupons === void 0 ? void 0 : getCategoryCoupons.length)) {
            var uniqueCouponIdNames = uniqueCouponId(couponIdNames);
            for(var i = 0; i < uniqueCouponIdNames.length; i++){
                var ref;
                var Element = document.getElementById(uniqueCouponIdNames[i]);
                var pos = (ref = Element === null || Element === void 0 ? void 0 : Element.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.right;
                if (pos > 0 && pos < 1.2 * deviceWidth/* deviceWidth */.o) {
                    pointToBeFilled = uniqueCouponIdNames[i];
                }
            }
        }
    }, [
        couponIdNames === null || couponIdNames === void 0 ? void 0 : couponIdNames.length
    ]);
    if (!isCustomWebsite) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return !!getCategoryCoupons.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCouponHorizontalViewContainer, {
                children: getCategoryCoupons.map(function(promo, index) {
                    var uniqueCouponId = "".concat(index).concat(promo.promo_id);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: uniqueCouponId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CategoryCoupon, {
                            desktopMarginLeft: index === 0 ? "10.1vw" : "14px",
                            coupon: promo,
                            mobileMarginLeft: index === 0 ? "14px" : "8px"
                        })
                    }, index);
                })
            }),
            renderDottedCircle()
        ]
    });
}
/* harmony default export */ var CouponDisplayWidget_CategoryCouponHorizontalView = (CategoryCouponHorizontalView);

// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(44779);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductDisplayWidget/utils.js


var PRODUCT_TAG_STORED_CONSTANT = "PRODUCT_TAG_STORED_CONSTANT";
var EMPTY_DATA = {
    allowReset: true,
    categoryItems: [],
    currentCategoryId: null
};
var getCachedCategoryItems = function() {
    return LocalStorageHelper/* default.get */.Z.get(PRODUCT_TAG_STORED_CONSTANT) || EMPTY_DATA;
};
var cacheCategoryItems = function(data) {
    var currentData = getCachedCategoryItems();
    var updatedData = (0,_object_spread/* default */.Z)({}, currentData, data);
    LocalStorageHelper/* default.add */.Z.add(PRODUCT_TAG_STORED_CONSTANT, updatedData);
};
var clearCachedItems = function() {
    cacheCategoryItems(EMPTY_DATA);
};

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var MiddleBody7_utils = __webpack_require__(8710);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductDisplayWidget/index.js















var CategoryProducsDisplayWidget = function(props) {
    var getActiveCategoryData = function getActiveCategoryData() {
        var allCategories = (0,_to_consumable_array/* default */.Z)(productTags || []).concat((0,_to_consumable_array/* default */.Z)(categories || []));
        var activeCatIndex = allCategories.findIndex(function(el) {
            return el.id === Number(catId);
        });
        return allCategories[activeCatIndex];
    };
    var filterCurrentCategoryItems = /**
   * This function will filter out items or apply sorting on items and return the new array of items
   * @param {*} filterOptions
   * @return {Array}
   */ function filterCurrentCategoryItems(filterOptions) {
        if (catalog_items[currentCategoryId]) {
            var ref;
            var currentCategoryItems = JSON.parse(JSON.stringify(catalog_items[currentCategoryId]));
            var filteredCategoryItems = [];
            var sortKey = "";
            if (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.is_hide_out_of_stock) {
                // removing out of stock items
                filteredCategoryItems = currentCategoryItems.filter(function(item) {
                    return item.available;
                });
            } else {
                filteredCategoryItems = (0,_to_consumable_array/* default */.Z)(currentCategoryItems);
            }
            if (filterOptions === null || filterOptions === void 0 ? void 0 : (ref = filterOptions.sort_option) === null || ref === void 0 ? void 0 : ref.sortType) {
                var ref1, ref2;
                sortKey = (filterOptions === null || filterOptions === void 0 ? void 0 : (ref1 = filterOptions.sort_option) === null || ref1 === void 0 ? void 0 : ref1.key) === "alphabet" ? "name" : "discounted_price";
                filteredCategoryItems = sortCategoryItems(filteredCategoryItems, sortKey, filterOptions === null || filterOptions === void 0 ? void 0 : (ref2 = filterOptions.sort_option) === null || ref2 === void 0 ? void 0 : ref2.sortType);
            }
            return filteredCategoryItems;
        } else {
            return [];
        }
    };
    var sortCategoryItems = /**
   * This function will apply the sorting on the array items. For sorting alphabatically we use localCompare.
   * @param {*} arrayToBeSorted : the array on which sorting will be applied
   * @param {*} sortingKey : key on which sorting will be applied i.e name or price
   * @param {*} sortingType : it will be ascending or descending
   * @return {Array}
   */ function sortCategoryItems(arrayToBeSorted, sortingKey, sortingType) {
        arrayToBeSorted.sort(function(a, b) {
            var key1;
            var key2;
            if (sortingKey === "name") {
                key1 = a[sortingKey].toLowerCase();
                key2 = b[sortingKey].toLowerCase();
            } else {
                key1 = a[sortingKey];
                key2 = b[sortingKey];
            }
            if (sortingType === "ascending") {
                if (key1 < key2) // sort ascending
                return -1;
                if (key1 > key2) return 1;
                return 0; // default return value (no sorting)
            } else {
                if (key1 > key2) // sort descending
                return -1;
                if (key1 < key2) return 1;
                return 0; // default return value (no sorting)
            }
        });
        return arrayToBeSorted;
    };
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var catId = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) || (props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.category_id);
    var ref2 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            categories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags
        };
    }), store_id = ref2.storeData.store_id, categories = ref2.categories, productTags = ref2.productTags;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(getActiveCategoryData()), activeCategoryData = ref3[0], setActiveCategoryData = ref3[1];
    var ref4 = (0,react.useState)([]), categoryItems = ref4[0], setCategoryItems = ref4[1];
    var ref5 = (0,react.useState)(null), currentCategoryId = ref5[0], setCurrentCategoryId = ref5[1];
    var ref6 = (0,react.useState)(0), categoryTagType = ref6[0], setCategoryTagType = ref6[1];
    var ref7 = (0,react.useState)({
        is_hide_out_of_stock: false,
        sort_option: {}
    }), currentSelectedFilter = ref7[0], setCurrentSelectedFilter = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 2), onItemClick = ref8[0], getLink = ref8[1];
    var ref9 = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalogData: state.catalogReducer
        };
    }), _catalogData = ref9.catalogData, catalog_items = _catalogData.catalog_items, productFilters = _catalogData.productFilters;
    (0,react.useEffect)(function() {
        (0,MiddleBody7_utils/* scrollIfItemPreviouslyClicked */.Wu)();
    }, []);
    /**
   * This useEffect will fetch all the items of active category
   */ (0,react.useEffect)(function() {
        var ref;
        setCurrentCategoryId(catId);
        if ((ref = (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories))) === null || ref === void 0 ? void 0 : ref.length) {
            // resetting product filters on fetching new category items
            dispatch((0,catalog/* setCatalogProductFilter */.ls)({
                is_hide_out_of_stock: false,
                sort_option: {}
            }));
            var categoryType = (productTags === null || productTags === void 0 ? void 0 : productTags.length) && productTags.findIndex(function(tag) {
                return tag.id === +catId;
            }) >= 0 ? constants/* CATEGORY_TYPE.TAG */.MI.TAG : constants/* CATEGORY_TYPE.CATEGORY */.MI.CATEGORY;
            var cachedData = getCachedCategoryItems();
            if (store_id) {
                if (!cachedData.allowReset && catId === (cachedData === null || cachedData === void 0 ? void 0 : cachedData.currentCategoryId)) {
                    setCategoryItems((cachedData === null || cachedData === void 0 ? void 0 : cachedData.categoryItems) || []);
                    cacheCategoryItems({
                        allowReset: true
                    });
                    dispatch((0,catalog/* saveCatalogsListBasedOnCategories */.BL)({
                        category_id: catId,
                        items: (cachedData === null || cachedData === void 0 ? void 0 : cachedData.categoryItems) || [],
                        isNextPage: false,
                        isPaginated: false
                    }));
                } else {
                    clearCachedItems();
                    getProducts(catId, categoryType);
                }
            }
            setCategoryTagType(categoryType);
            if (catId) {
                var data = getActiveCategoryData();
                setActiveCategoryData(data);
            }
        }
    }, [
        categories,
        productTags,
        catId,
        store_id
    ]);
    (0,react.useEffect)(function() {
        // setting the current category items in view
        if (Object.keys(catalog_items).length && catalog_items[currentCategoryId]) {
            setCategoryItems(catalog_items[currentCategoryId]);
        }
    }, [
        catalog_items
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        // this useeffect will be used for applying filter and sorting options on the categoryItems array
        if ((categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length) && Object.keys(productFilters).length && ((productFilters === null || productFilters === void 0 ? void 0 : productFilters.is_hide_out_of_stock) !== currentSelectedFilter.is_hide_out_of_stock || (productFilters === null || productFilters === void 0 ? void 0 : (ref = productFilters.sort_option) === null || ref === void 0 ? void 0 : ref.id) !== (currentSelectedFilter === null || currentSelectedFilter === void 0 ? void 0 : (ref1 = currentSelectedFilter.sort_option) === null || ref1 === void 0 ? void 0 : ref1.id))) {
            setCurrentSelectedFilter(productFilters);
            setCategoryItems(filterCurrentCategoryItems(productFilters));
        }
    }, [
        productFilters,
        categoryItems
    ]);
    var getProducts = function(id, type) {
        if (!store_id) return;
        return new Promise(function(resolve, reject) {
            dispatch((0,catalog/* fetchCatalogItemsByCategoryId */.Is)({
                store_id: store_id,
                category_id: id,
                category_type: type
            }, function(status) {
                if (status) {
                    resolve(status);
                } else {
                    reject(status);
                }
            }));
        });
    };
    var handleImageClick = function(data) {
        cacheCategoryItems({
            allowReset: false,
            categoryItems: categoryItems,
            currentCategoryId: currentCategoryId
        });
        onItemClick(data);
    };
    var renderProductDisplayWidget = function(widgetName) {
        switch(widgetName){
            case "CategoryWidgetGridView1":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDisplayWidget_CategoryCouponHorizontalView, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridView, {
                            onItemsImageClick: handleImageClick,
                            getLink: getLink,
                            categoryItems: categoryItems,
                            activeCategoryData: activeCategoryData,
                            config: props.config
                        })
                    ]
                });
            case "CategoryWidgetHorizontalView1":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDisplayWidget_CategoryCouponHorizontalView, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalView, {
                            onItemsImageClick: handleImageClick,
                            getLink: getLink,
                            categoryItems: categoryItems,
                            activeCategoryData: activeCategoryData,
                            config: props.config,
                            categoryTagType: categoryTagType
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    };
    return renderProductDisplayWidget(props.widgetName);
};
/* harmony default export */ var ProductDisplayWidget = (CategoryProducsDisplayWidget);


/***/ }),

/***/ 7780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ Card1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/Card1/Card.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  border: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  cursor: ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: '100%';\n  height: 'auto';\n  position: relative;\n  object-fit: contain;\n  display: flex;\n\n  & > img {\n    width: 100%;\n    object-position: center center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  padding: ",
        ";\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0 0 12px 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  padding: ",
        ";\n\n  & > span:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 2px 4px;\n  margin-bottom: 4px;\n  color: #ffffff;\n  font-size: 11px;\n  background-color: ",
        ";\n  white-space: nowrap;\n  margin-right: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  margin: 0.5rem 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 14px;\n  ",
        "\n  font-size: 15px;\n  word-break: break-word;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  color: ",
        ";\n  letter-spacing: 1.5px;\n  font-size: 16px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  text-decoration: line-through;\n  color: rgba(0, 0, 0, 0.3);\n  letter-spacing: 1.3px;\n  margin-left: 10px;\n  font-size: 13px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: absolute;\n  background-color: #3ea200;\n  color: #ffffff;\n  font-size: 11px;\n  text-transform: uppercase;\n  z-index: 2;\n  padding: 2px 3px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  flex-direction: column;\n\n  @media screen and (min-width: 401px) {\n    margin-left: 10px;\n    margin-top: 0.5rem;\n  }\n\n  @media screen and (max-width: 400px) {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  @media screen and (min-width: 767px) {\n    font-size: 22px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  color: #9c9c9c;\n  font-weight: 400;\n  letter-spacing: 0.26px;\n  line-height: 1.5;\n\n  ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 12px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  letter-spacing: 1.5px;\n  font-size: 14px;\n  font-weight: 700;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}



var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardContainer",
    componentId: "sc-dcb82913-0"
})(_templateObject(), function(props) {
    return !props.imageUrl && "0.4px solid #C7C7C7;";
}, function(props) {
    return !props.imageUrl && "20px;";
}, function(props) {
    return !props.imageUrl && "4px;";
}, function(props) {
    return props.isAvailable || props.isNotifyProductEnabled ? "pointer" : "default";
}, function(props) {
    return !!props.isAvailable || props.isB2bStore ? null : "filter: grayscale(1);";
}, function(props) {
    return !props.imageUrl ? " grid-column: 1 / -1;" : " max-width: 100%;";
});
var CardBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardBody",
    componentId: "sc-dcb82913-1"
})(_templateObject1());
var CardImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardImage",
    componentId: "sc-dcb82913-2"
})(_templateObject2());
var CardMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardMain",
    componentId: "sc-dcb82913-3"
})(_templateObject3(), function(param) {
    var padding = param.padding;
    return padding ? "4px 6px" : "12px 0 14px";
}, function(props) {
    return props.imageUrl && "\n    @media screen and (max-width: 400px) {\n      flex-direction: column;\n    }\n  ";
});
var CardData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardData",
    componentId: "sc-dcb82913-4"
})(_templateObject4());
var CardInventory = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardInventory",
    componentId: "sc-dcb82913-5"
})(_templateObject5());
var CardTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardTags",
    componentId: "sc-dcb82913-6"
})(_templateObject6(), function(param) {
    var padding = param.padding;
    return padding;
});
var CardTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardTag",
    componentId: "sc-dcb82913-7"
})(_templateObject7(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var CardTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CardTitle",
    componentId: "sc-dcb82913-8"
})(_templateObject8(), function(props) {
    return props.categoryCard && "text-align: center;";
});
var CardPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardPrice",
    componentId: "sc-dcb82913-9"
})(_templateObject9());
var AmountDiscounted = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountDiscounted",
    componentId: "sc-dcb82913-10"
})(_templateObject10(), function(props) {
    return props.fontColor;
});
var AmountActual = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountActual",
    componentId: "sc-dcb82913-11"
})(_templateObject11());
var CardDiscount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardDiscount",
    componentId: "sc-dcb82913-12"
})(_templateObject12(), function(props) {
    return props.imageUrl ? "bottom: 0px;" : "top: -25px;";
});
var ButtonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ButtonContainer",
    componentId: "sc-dcb82913-13"
})(_templateObject13());
var Button = (0,styled_components_browser_esm/* default */.ZP)(AtomicComponents/* CartButton */.WE).withConfig({
    displayName: "Button",
    componentId: "sc-dcb82913-14"
})(_templateObject14());
var CardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardDescription",
    componentId: "sc-dcb82913-15"
})(_templateObject15(), function(props) {
    return props.isAvailable && "\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;    \n    ";
});
var B2BPriceText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "B2BPriceText",
    componentId: "sc-dcb82913-16"
})(_templateObject16(), function(props) {
    return props.fontColor;
}, constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/isNotifyProductEnabled.js
var isNotifyProductEnabled = __webpack_require__(32953);
// EXTERNAL MODULE: ./src/utils/checkForLimitedQuantity.js
var checkForLimitedQuantity = __webpack_require__(27994);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(53716);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(13051);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/returnSpecificImageUrl.js
var returnSpecificImageUrl = __webpack_require__(28631);
// EXTERNAL MODULE: ./src/components/ProductMediaRenderer/MediaContainer.tsx
var MediaContainer = __webpack_require__(48577);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/CardSkeleton.tsx
var CardSkeleton = __webpack_require__(79062);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(27941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ItemImage/index.tsx







// eslint-disable-next-line no-undef


var LazyMotionSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4914), __webpack_require__.e(448), __webpack_require__.e(7357)]).then(__webpack_require__.bind(__webpack_require__, 27357)).then(function(mod) {
        return mod.motion.section;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46431)
            ];
        }
    },
    ssr: false
});
var LazyMotionDiv = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4914), __webpack_require__.e(448), __webpack_require__.e(7357)]).then(__webpack_require__.bind(__webpack_require__, 27357)).then(function(mod) {
        return mod.motion.div;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46431)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {});
    }
});
var slideMotionFirst = {
    rest: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    },
    hover: {
        x: "-100%",
        opacity: 0,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    }
};
var slideMotionSecond = {
    rest: {
        x: "100%",
        opacity: 0,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    },
    hover: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    }
};
var dissolveMotionFirst = {
    rest: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.8
        }
    },
    hover: {
        x: 0,
        opacity: 0,
        transition: {
            duration: 0.8
        }
    }
};
var dissolveMotionSecond = {
    rest: {
        x: 0,
        opacity: 0,
        transition: {
            duration: 0.8
        }
    },
    hover: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.8
        }
    }
};
var defaultImageUrl = "https://cdn.dotpe.in/longtail/store-items/default_image.png";
var ItemImage = function(props) {
    var ref, ref1;
    var ref2 = (0,react.useState)({
        first: null,
        second: null
    }), animationProperties = ref2[0], setAnimationProperties = ref2[1];
    var ref3 = (0,react.useState)([]), imgArr = ref3[0], setImgArr = ref3[1];
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    }).theme;
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.categoryConfig) === null || ref === void 0 ? void 0 : ref.animation) {
            var ref1;
            switch(props === null || props === void 0 ? void 0 : (ref1 = props.categoryConfig) === null || ref1 === void 0 ? void 0 : ref1.animation){
                case "slide":
                    {
                        setAnimationProperties({
                            first: slideMotionFirst,
                            second: slideMotionSecond
                        });
                        break;
                    }
                case "pop":
                    {
                        setAnimationProperties({
                            first: dissolveMotionFirst,
                            second: dissolveMotionSecond
                        });
                        break;
                    }
                default:
                    setAnimationProperties({
                        first: null,
                        second: null
                    });
                    break;
            }
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref = props.categoryConfig) === null || ref === void 0 ? void 0 : ref.animation
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((props === null || props === void 0 ? void 0 : (ref = props.productData) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.length) > 2) {
            var ref2;
            var images = props === null || props === void 0 ? void 0 : (ref2 = props.productData) === null || ref2 === void 0 ? void 0 : ref2.images;
            // if image length is more than 2
            // reduce array length down to 2
            images.length = 2;
            setImgArr(images);
        } else {
            var ref3;
            setImgArr(props === null || props === void 0 ? void 0 : (ref3 = props.productData) === null || ref3 === void 0 ? void 0 : ref3.images);
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref1 = props.productData) === null || ref1 === void 0 ? void 0 : ref1.images
    ]);
    var checkForMediaType = function(image) {
        if (image.media_type === 2) return defaultImageUrl;
        else return (0,returnSpecificImageUrl/* returnSpecificImageUrl */.B)({
            theme: theme,
            item: image
        });
    };
    var singleImageRender = function(image) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-h-full tw-w-full tw-bg-contain tw-bg-center tw-bg-no-repeat",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                    layout: "fill",
                    objectFit: "contain",
                    loading: "lazy",
                    decoding: "async",
                    src: checkForMediaType(image)
                })
            })
        });
    };
    var multiImageRender = function(imgArr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotionSection, {
                className: "image-wrap tw-h-full tw-w-full !tw-bg-transparent",
                initial: "rest",
                whileHover: "hover",
                animate: "rest",
                children: !!(imgArr === null || imgArr === void 0 ? void 0 : imgArr.length) && imgArr.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotionDiv, {
                        variants: index === 0 ? animationProperties.first : animationProperties.second,
                        className: "collection-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                            layout: "fill",
                            objectFit: "contain",
                            loading: "lazy",
                            decoding: "async",
                            src: checkForMediaType(image)
                        })
                    }, index);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-100 framer-card",
        children: [
            (imgArr === null || imgArr === void 0 ? void 0 : imgArr.length) === 1 || !imgArr ? singleImageRender(imgArr ? imgArr[0] : {
                image_url: defaultImageUrl
            }) : multiImageRender(imgArr),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-type",
                children: (0,canShowPDPSystem/* canShowPDPSystem */.R)(theme === null || theme === void 0 ? void 0 : theme.theme_class) ? "View Product" : "Quick View"
            })
        ]
    });
};
/* harmony default export */ var DesignSystem_ItemImage = (ItemImage);

// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(22787);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/Card1/index.js


















var ProductCardWidget1 = function(props) {
    var removeTagsAndReturn = // function to remove all anchor tags from string
    function removeTagsAndReturn(str) {
        if (checkRenderEnv/* IS_SERVER */.W6) return str;
        var tmp = document.createElement("div");
        // add string to created div as html
        tmp.innerHTML = str;
        // get all anchor tags added to created element
        var anchor_tag_collection = tmp.getElementsByTagName("a");
        // iterate over all the tags and remove them from the HTML collection
        if (anchor_tag_collection.length) {
            // convert HTML collection to array
            Array.from(anchor_tag_collection).forEach(function(tag) {
                // remove the tags
                if (tag) {
                    tag.parentNode.removeChild(tag);
                }
            });
        }
        return tmp.textContent || tmp.innerText || "";
    };
    var handleOnClickCardContainer = function handleOnClickCardContainer() {
        if ((data === null || data === void 0 ? void 0 : data.available) || (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)()) {
            props.onItemClick && props.onItemClick();
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = props.data, _showCategoryCard = props.showCategoryCard, showCategoryCard = _showCategoryCard === void 0 ? false : _showCategoryCard, _imageUrl = props.imageUrl, imageUrl = _imageUrl === void 0 ? "https://picsum.photos/300/300" : _imageUrl, _noTags = props.noTags, noTags = _noTags === void 0 ? false : _noTags;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), userData = ref8.userData, cartData = ref8.cartData;
    var theme = storeData.theme, store_id = storeData.store_id, premium = storeData.premium;
    var ref9 = (0,react.useState)(0), discountPercent = ref9[0], setDiscountPercent = ref9[1];
    var ref10 = (0,useCartHandler/* useCartHandlers */.u)(), setProductData = ref10.setProductData, onPersonalizeProductClick = ref10.onPersonalizeProductClick, handleIncreamentClick = ref10.handleIncreamentClick, handleDecreamentClick = ref10.handleDecreamentClick, handleSetProductCustomizationCount = ref10.handleSetProductCustomizationCount;
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var itemIndexInCart = cartData.items.findIndex(function(el) {
        return (el.id || el.item_id) === (data === null || data === void 0 ? void 0 : data.id);
    });
    (0,react.useEffect)(function() {
        if (data) {
            var percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(data === null || data === void 0 ? void 0 : data.price, data === null || data === void 0 ? void 0 : data.discounted_price);
            setDiscountPercent(percent ? percent : 0);
        }
    }, [
        data
    ]);
    var handleAddRemoveItem = function(type) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var productItem = cartData.items[itemIndexInCart];
        // managed_inventory !== 0. available_quantity !== 0.
        // don't proceed to control flow if available_quantity is 0
        if (type === "inc" && (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(productItem)) {
            (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
            return;
        }
        /** Check if variant present in this item */ if (((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.variants_count) > 0) {
            var ref3;
            dispatch((0,common/* saveProductLoaderId */.XG)((ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.id));
            /** check if item exist in cart */ if (itemIndexInCart !== -1) {
                setProductData && setProductData(productItem);
                switch(type){
                    case "inc":
                        dispatch((0,common/* setVariantModalVisibility */.VZ)(true));
                        break;
                    case "dec":
                        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(true));
                        break;
                }
            } else {
                var ref4;
                /** get the details item for this item id */ dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: store_id,
                    item_id: (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.id,
                    src: "design_system_product_item_widget_card1"
                }, true, function(data) {
                    return setProductData && setProductData(data);
                }));
            }
        } else {
            if (data === null || data === void 0 ? void 0 : data.product_personalization) {
                handleSetProductCustomizationCount && handleSetProductCustomizationCount(data);
                setProductData && setProductData(data);
                switch(type){
                    case "add":
                        onPersonalizeProductClick && onPersonalizeProductClick();
                        break;
                    case "inc":
                        handleIncreamentClick && handleIncreamentClick(type, data);
                        break;
                    case "dec":
                        handleDecreamentClick && handleDecreamentClick(type, data);
                        break;
                    default:
                        break;
                }
            } else {
                var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, data, cartData);
                dispatch((0,cart/* saveCart */.FP)(newState));
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
        isAvailable: data === null || data === void 0 ? void 0 : data.available,
        isB2bStore: isB2bStore,
        reactSlick: props.reactSlick,
        categoryCard: showCategoryCard,
        imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
        isNotifyProductEnabled: (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)(),
        style: {
            boxShadow: premium === 0 && theme.is_demo === 0 ? "0 2px 6px #4a4a4a" : ""
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleOnClickCardContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_ItemImage, {
                        categoryConfig: props.categoryConfig,
                        productData: data
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardMain, {
                    imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
                    padding: premium === 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardData, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex pr2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                                categoryCard: showCategoryCard,
                                                onClick: handleOnClickCardContainer,
                                                property: "name",
                                                children: (data === null || data === void 0 ? void 0 : data.name) || "Available Items"
                                            })
                                        }),
                                        (props === null || props === void 0 ? void 0 : (ref = props.productConfig) === null || ref === void 0 ? void 0 : ref.add_to_cart_visibility) === true && (data === null || data === void 0 ? void 0 : data.available) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(cartData.items[itemIndexInCart]),
                                                    fontSize: "14",
                                                    onChange: handleAddRemoveItem,
                                                    quantity: itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0
                                                }),
                                                ((ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.variants_count) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "variant--count-icontext",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                                                        }),
                                                        (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.variants_count,
                                                        " options"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!(data === null || data === void 0 ? void 0 : data.available) && (0,checkForLimitedQuantity/* checkForLimitedQuantity */.U)(data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInventory, {
                                    className: "highlighter-red-color",
                                    children: "Limited Stock Left"
                                }),
                                isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BPriceText, {
                                    fontColor: theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
                                    children: (data === null || data === void 0 ? void 0 : (ref4 = data.b2b_pricing_info) === null || ref4 === void 0 ? void 0 : ref4.price_range) || "Price on Request"
                                }),
                                !showCategoryCard && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardPrice, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountDiscounted, {
                                                fontColor: theme === null || theme === void 0 ? void 0 : (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "₹"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: data === null || data === void 0 ? void 0 : data.discounted_price
                                                    })
                                                ]
                                            }),
                                            (data === null || data === void 0 ? void 0 : data.discounted_price) !== (data === null || data === void 0 ? void 0 : data.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountActual, {
                                                children: [
                                                    "₹",
                                                    data === null || data === void 0 ? void 0 : data.price
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !showCategoryCard && !imageUrl && discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDiscount, {
                            children: "".concat(discountPercent, "% OFF")
                        })
                    ]
                }),
                !noTags && (data === null || data === void 0 ? void 0 : (ref6 = data.tags) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTags, {
                    padding: "0 0 8px",
                    children: data === null || data === void 0 ? void 0 : (ref7 = data.tags) === null || ref7 === void 0 ? void 0 : ref7.map(function(tag) {
                        return tag.is_active !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTag, {
                            backgroundColor: tag.tag_color,
                            children: tag.name
                        }, tag.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: premium === 0 && "ph2 pb2",
                    property: "description",
                    children: !(data === null || data === void 0 ? void 0 : data.available) && !isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        children: "Out of stock"
                    }) : !showCategoryCard && (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        isAvailable: !!(data === null || data === void 0 ? void 0 : data.available),
                        children: removeTagsAndReturn(data === null || data === void 0 ? void 0 : data.description)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Card1 = (ProductCardWidget1);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/index.js




/***/ }),

/***/ 68464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39996);



/***/ }),

/***/ 73409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Link/link.module.scss
var link_module = __webpack_require__(70919);
var link_module_default = /*#__PURE__*/__webpack_require__.n(link_module);
;// CONCATENATED MODULE: ./src/components/Link/Link.tsx



var Link = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: props.href,
        target: props.target,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (link_module_default()).link,
            children: props.children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Link/index.tsx



/***/ }),

/***/ 48577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MediaContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68037);




function MediaContainer(props) {
    var getDimensions = function getDimensions() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, width ? {
            width: width
        } : {}, height ? {
            height: height
        } : {});
    };
    var _onClick = props.onClick, onClick = _onClick === void 0 ? null : _onClick, _onMouseEnter = props.onMouseEnter, onMouseEnter = _onMouseEnter === void 0 ? null : _onMouseEnter, _onMouseLeave = props.onMouseLeave, onMouseLeave = _onMouseLeave === void 0 ? null : _onMouseLeave, _isSelected = props.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _containerClasses = props.containerClasses, containerClasses = _containerClasses === void 0 ? "" : _containerClasses, _width = props.width, width = _width === void 0 ? null : _width, _height = props.height, height = _height === void 0 ? null : _height, _borderWidth = props.borderWidth, borderWidth = _borderWidth === void 0 ? 0.6 : _borderWidth, _borderColor = props.borderColor, borderColor = _borderColor === void 0 ? "#858585" : _borderColor, children = props.children;
    var ref = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            theme: state.storeReducer.store.theme
        };
    }), _theme = ref.theme, product_aspect_ratio = _theme.product_aspect_ratio, tmp = _theme.product_base_image_color, backgroundColor = tmp === void 0 ? "#FFFFFF" : tmp;
    var aspectRatio = product_aspect_ratio || 100; // Fallback aspect ratio if backend sends 0
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative tw-flex tw-items-center tw-justify-center  tw-overflow-hidden ".concat(containerClasses),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, getDimensions()), {
            borderStyle: isSelected ? "solid" : "none",
            borderWidth: borderWidth,
            borderColor: borderColor,
            aspectRatio: aspectRatio / 100,
            backgroundColor: backgroundColor
        }),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: children
    });
}


/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OrderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 71386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ calculateArrowTopPos; }
/* harmony export */ });
/**
 * function to calculate Y-axis position of arrow
 * considering the dynamic acpect ratio of card
 * if card offset width is not 300, calculate card width
 *
 * @param {*} commonConfigData
 * @param {*} cardHeight
 * @return {*} string
 */ var calculateArrowTopPos = function() {
    var commonConfigData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cardHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _aspect_ratio = commonConfigData.aspect_ratio, aspect_ratio = _aspect_ratio === void 0 ? null : _aspect_ratio;
    if (!aspect_ratio) return "50%";
    var height = cardHeight * (aspect_ratio / 100) / 2;
    return height ? "".concat(height, "px") : "50%";
};


/***/ }),

/***/ 27994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkForLimitedQuantity; }
/* harmony export */ });
/**
 * check if stocks are low in quantity
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var checkForLimitedQuantity = function(stockItem) {
    if (!((stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.low_quantity))) {
        return false;
    }
    return stockItem.available_quantity <= stockItem.low_quantity;
};


/***/ }),

/***/ 40619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 32953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isNotifyProductEnabled; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);

var isNotifyProductEnabled = function() {
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.notify_me_enabled) === 1) {
        return true;
    }
    return false;
};


/***/ }),

/***/ 73175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ itemQuantityValueComparison; }
/* harmony export */ });
/**
 * function to check if managed inventory is allowed
 * quantity and available_quantity comparison
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var itemQuantityValueComparison = function(stockItem) {
    if (!((stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.quantity))) {
        return false;
    }
    return stockItem.quantity >= stockItem.available_quantity;
};


/***/ }),

/***/ 43090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ returnCommonConfigData; }
/* harmony export */ });
/**
 * common function to return config data for card configuration changes
 * @param {*} {activeCategoryConfig, productConfig}
 * @return {*} object - config
 */ var returnCommonConfigData = function(param) {
    var _activeCategoryConfig = param.activeCategoryConfig, activeCategoryConfig = _activeCategoryConfig === void 0 ? {} : _activeCategoryConfig, _productConfig = param.productConfig, productConfig = _productConfig === void 0 ? {} : _productConfig;
    if (activeCategoryConfig && Object.keys(activeCategoryConfig).length > 0) {
        return activeCategoryConfig;
    } else if (productConfig && Object.keys(productConfig).length > 0) {
        return productConfig;
    } else {
        return {};
    }
};


/***/ }),

/***/ 28631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ returnSpecificImageUrl; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/* harmony import */ var _compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40619);


/*
 returns either image_url or thumbnail_url,
 depending on the configuration of theme config 'product_image_quality_flag'
 */ function returnSpecificImageUrl(param) {
    var theme = param.theme, item = param.item;
    if (!theme || !(theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag)) return (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
    return (theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_CONFIG_CONSTANT.THUMBNAIL_IMAGE */ .of.THUMBNAIL_IMAGE ? (item === null || item === void 0 ? void 0 : item.thumbnail_url) || (item === null || item === void 0 ? void 0 : item.image_url) : (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
}


/***/ }),

/***/ 87243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ }),

/***/ 52925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ showViewMoreBtn; }
/* harmony export */ });
/**
 * returns boolean. conditionally render View More button
 * based on maxLimit and item list
 * @param {*} maxLimit number
 * @param {*} itemList array
 * @return {*} boolean
 */ var showViewMoreBtn = function() {
    var maxLimit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, itemList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!maxLimit && !(itemList === null || itemList === void 0 ? void 0 : itemList.length)) return false;
    return maxLimit ? (itemList === null || itemList === void 0 ? void 0 : itemList.length) > maxLimit : false;
};


/***/ }),

/***/ 70919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__imOxT"};

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ })

}]);